import { render, staticRenderFns } from "./SubmissionsDropdown.vue?vue&type=template&id=7a9b59fc&scoped=true&"
import script from "./SubmissionsDropdown.vue?vue&type=script&lang=js&"
export * from "./SubmissionsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionsDropdown.vue?vue&type=style&index=0&id=7a9b59fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9b59fc",
  null
  
)

export default component.exports